/*
 * Copyright (c) 2025. Jellybean B.V.
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
* sihwdatumveld.module.ts
* 17-11-2021 - Jelmer Jellema - Spin in het Web B.V.
*
* Eenvoudige datuminput met validatie en rewrite
* <sihwdatumveld [(ngModel)=....] format=string
* format is standaard "DD-MM-YYYY".
* De waarde is altijd YYYY-MM-DD, we parsen op format
* Overgenomen attributen: placeholder, size
* Overige inputs:
* - control-class: class die op de interne control wordt gezet
* Stuurt de volgende events door vanaf de ingebouwde input:
*   - focus
*/
import {NgModule} from '@angular/core';
import {SihwlogModule} from '../../sihwlog/sihwlog.module';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Sihwdatumveld} from './sihwdatumveld';

@NgModule({
  declarations: [
    Sihwdatumveld
  ],
  imports: [
    SihwlogModule,
    CommonModule,
    FormsModule
  ],
  exports: [Sihwdatumveld]
}) export class SihwdatumveldModule {}
